export default __webpack_public_path__ + "static/media/72_photo.79493eef.jpg";